import { SET_ANSWERS, SET_FORWARDED } from "../types/forwardTypes";

const initialState = {
  answers: {},
  selected: null
};

const forwardReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_FORWARDED:
      return { ...state, selected: action.payload };
    case SET_ANSWERS:
      return { ...state, answers: action.payload };
    default:
      return state;
  }
};

export default forwardReducer;
